import { Route, Routes } from "react-router-dom";
import Login from "../views/auth/Login";

export default function Auth() {
  return (
    <>
      <main>
        <section className="relative w-full h-full min-h-screen">
          <div
            style={{
              backgroundImage:
                "url(" +
                require("../assets/img/register_bg_2.png").default +
                ")",
            }}
          ></div>
          <Routes>
            <Route path="login" element={<Login />} />
          </Routes>
        </section>
      </main>
    </>
  );
}
